import {
  ADD_CUSTOMER_BRANCH_FAIL,
  ADD_CUSTOMER_BRANCH_REQUEST,
  ADD_CUSTOMER_BRANCH_SUCCESS,
  DELETE_CUSTOMER_BRANCH_FAIL,
  DELETE_CUSTOMER_BRANCH_REQUEST,
  DELETE_CUSTOMER_BRANCH_SUCCESS,
  GET_CUSTOMER_BRANCH_LIST_REQUEST,
  GET_CUSTOMER_BRANCH_LIST_FAIL,
  GET_CUSTOMER_BRANCH_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_BRANCH_FAIL,
  GET_SINGLE_CUSTOMER_BRANCH_REQUEST,
  GET_SINGLE_CUSTOMER_BRANCH_SUCCESS,
  UPDATE_CUSTOMER_BRANCH_FAIL,
  UPDATE_CUSTOMER_BRANCH_REQUEST,
  UPDATE_CUSTOMER_BRANCH_SUCCESS,
} from "src/constants/types";

export const customerBranchReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CUSTOMER_BRANCH_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CUSTOMER_BRANCH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customerBranches: actions.payload,
        error: "",
      };
    case GET_CUSTOMER_BRANCH_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CUSTOMER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CUSTOMER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CUSTOMER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CUSTOMER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CUSTOMER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CUSTOMER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CUSTOMER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CUSTOMER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        customerBranch: actions.payload,
      };
    case GET_SINGLE_CUSTOMER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CUSTOMER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CUSTOMER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CUSTOMER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
